import { put, takeEvery, call } from "redux-saga/effects";
// import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import endpoints from "../endpoints";
import { toast } from "react-toastify";
// import api from "../api";
import fmApi from "../APIWrapper";

// function* commonFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });

//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();
//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({
//         type: `${value.initAction}`,
//       });
//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: `${value.failAction}`, error: err });
//     } else {
//     }
//   }
// }

function* commonPostFunction(value) {
  const token = localStorage.getItem("fmsToken");
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Authorization: `Bearer ${token}`,
        type: "Web",
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: `${value.sucessAction}`,
        payload: resJSON,
      });
      yield put({
        type: `${value.initAction}`,
      });
      yield toast.success(value.toastMsg, {
        autoClose: 3000,
      });
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield put({ type: `${value.failAction}`, error: err });
        yield toast.error(`${endpoints.status400}`);
      } else if (err.status === 500) {
        yield put({ type: `${value.failAction}`, error: err });
        yield toast.error(`${endpoints.status500}`);
      } else {
      }
    }
  }
}

function* fetchSupport() {
  const societyName = JSON.parse(localStorage.getItem("FmsUser")).society_name;
  // const token = localStorage.getItem("fmsToken");
  const data = {
    societyName: societyName,
  };
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/watersourceservice/society/alltickets`,
    //   {
    //     method: "POST",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();
    const resJSON = yield call(fmApi.FetchSupportTicketsApi, data);
    yield put({
      type: actionTypes.FETCH_SUPPORT_SUCCESS_ACTION,
      payload: resJSON?.data,
    });
    // }
  } catch (err) {
    if (err.status === 401) {
    }
    yield put({ type: actionTypes.FETCH_SUPPORT_FAIL_ACTION, payload: err });
  }
}

function* addSupport(value) {
  // let formdata = new FormData();
  // let requestData = {
  //   description: value.value.desc,
  //   email: value.value.requester,
  //   subject: value.value.subject,
  //   priority: value.value.priority,
  //   status: 2,
  //   custom_fields: {
  //     address: value.value.flatNumber,
  //     cf_society_name: value.value.socityName,
  //     mobile_number: value.value.mobile,
  //   },
  //   cc_emails: [value.value.ccemail],
  // };
  // formdata.append("request", JSON.stringify(requestData));

  // if (value.value.attachment && value.value.attachment.length > 0) {
  //   for (let i = 0; i < value.value.attachment.length; i++) {
  //     const file = value.value.attachment[i];
  //     formdata.append("attachments[]", file, file.name);
  //   }
  // }

  // try {
  // let params = {
  //   api: `${appConfig.urlPrefixIp}/watersourceservice/society/createticket`,
  //   method: "POST",
  //   sucessAction: actionTypes.ADD_SUPPORT_SUCCESS_ACTION,
  //   toastMsg: "Ticket created successfully",
  //   initAction: actionTypes.FETCH_SUPPORT_INIT_ACTION,
  //   failAction: actionTypes.ADD_SUPPORT_FAIL_ACTION,
  //   body: formdata,
  // };
  //     const Res = yield call(commonPostFunction, params);
  //     return Res;
  //   } catch (e) {}
  // }

  const societyName = JSON.parse(localStorage.getItem("FmsUser")).society_name;
  let attachmentArr = [];

  const convertToBase64 = (file, callback) => {
    if (!file) return callback(null);

    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result.split(",")[1];
      callback(base64);
    };
    reader.onerror = (error) => {
      console.error("Error converting file:", error);
      callback(null);
    };
    reader.readAsDataURL(file);
  };

  // --- Helper to convert all files sequentially ---
  const processFiles = (files, done) => {
    let results = [];
    let count = 0;

    files.forEach((file, index) => {
      convertToBase64(file, (base64Content) => {
        results.push({
          name: file.name,
          content: base64Content,
          type: file.type,
        });

        count++;
        if (count === files.length) {
          done(results); // All files processed
        }
      });
    });
  };

  if (value.value.attachment && value.value.attachment.length > 0) {
    yield new Promise((resolve) => {
      processFiles(value.value.attachment, (converted) => {
        attachmentArr = converted;
        resolve();
      });
    });
  }

  let requestData = {
    description: value.value.desc,
    email: value.value.requester,
    subject: value.value.subject,
    priority: value.value.priority,
    status: 2,
    custom_fields: {
      address: value.value.flatNumber,
      cf_society_name: value.value.socityName,
      mobile_number: value.value.mobile,
    },
    cc_emails: [value.value.ccemail],
    attachments: attachmentArr,
  };

  const data = {
    requestData,
    societyName,
  };

  try {
    const resJSON = yield call(fmApi.PostSupportTicketsApi, data);
    if (resJSON.status === "Success") {
      yield put({
        type: actionTypes.ADD_SUPPORT_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({
        type: actionTypes.FETCH_SUPPORT_INIT_ACTION,
      });
      yield toast.success("Ticket created successfully", {
        autoClose: 3000,
      });
    } else {
      yield toast.error("Failed create ticket", {
        autoClose: 3000,
      });
    }

    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield put({ type: actionTypes.ADD_SUPPORT_FAIL_ACTION, error: err });
        yield toast.error(`${endpoints.status400}`);
      } else if (err.status === 500) {
        yield put({ type: actionTypes.ADD_SUPPORT_FAIL_ACTION, error: err });
        yield toast.error(`${endpoints.status500}`);
      } else {
      }
    }
  }
}

function* fetchSupportIssueData(value) {
  // const token = localStorage.getItem("fmsToken");
  const data = {
    ticketId: value?.value?.id || 0,
  };

  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/watersourceservice/society/ticket`,
    //   {
    //     method: "POST",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();
    const resJSON = yield call(fmApi.FetchSupportTicketsByIdApi, data);

    yield put({
      type: actionTypes.FETCH_SUPPORT_ISSUE_SUCCESS_ACTION,
      payload: resJSON.data,
    });
    // }
  } catch (err) {
    if (err.status === 401) {
    }
    yield put({
      type: actionTypes.FETCH_SUPPORT_ISSUE_FAIL_ACTION,
      payload: err,
    });
  }
}

function* fetchSupportChatData(value) {
  // const token = localStorage.getItem("fmsToken");
  const data = {
    ticketId: value?.value?.id || 0,
  };
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/watersourceservice/society/ticketconversation`,
    //   {
    //     method: "POST",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();
    const resJSON = yield call(fmApi.FetchSupportTicketsConversationApi, data);
    yield put({
      type: actionTypes.FETCH_SUPPORT_CHAT_SUCCESS_ACTION,
      payload: resJSON?.data,
    });
    // }
  } catch (err) {
    if (err.status === 401) {
    }
    yield put({
      type: actionTypes.FETCH_SUPPORT_CHAT_FAIL_ACTION,
      payload: err,
    });
  }
}

function* addIssueReply(value) {
  // let formdata = new FormData();
  let request = {
    body: value?.value?.replayMessage || "",
    ticketId: value?.value?.ItemList?.id || "",
    user_id: value?.value?.ItemList?.requester_id || "",
  };
  // formdata.append("request", JSON.stringify(request));
  try {
    //     let params = {
    //       api: `${appConfig.urlPrefixIp}/watersourceservice/society/ticketreply`,
    //       method: "POST",
    //       sucessAction: actionTypes.ADD_ISSUE_REPLY_SUCCESS_ACTION,
    //       toastMsg: "Reply sent successfully",
    //       failAction: actionTypes.ADD_ISSUE_REPLY_FAIL_ACTION,
    //       body: formdata,
    //     };
    //     const Res = yield call(commonPostFunction, params);
    //     return Res;
    //   } catch (e) {}
    // }

    const resJSON = yield call(fmApi.PostSupportTicketsReplyApi, request);
    yield put({
      type: actionTypes.ADD_ISSUE_REPLY_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield toast.success("Reply sent successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield put({
          type: actionTypes.ADD_ISSUE_REPLY_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status400}`);
      } else if (err.status === 500) {
        yield put({
          type: actionTypes.ADD_ISSUE_REPLY_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status500}`);
      } else {
      }
    }
  }
}

function* fetchAgentsName() {
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/watersourceservice/society/agents`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SUPPORT_AGENT_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SUPPORT_AGENT_FAIL_ACTION,
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchSupportAgentsApi);

    yield put({
      type: actionTypes.FETCH_SUPPORT_AGENT_SUCCESS_ACTION,
      payload: resJSON?.data,
    });
    // }
  } catch (err) {
    if (err.status === 401) {
    }
    yield put({
      type: actionTypes.FETCH_SUPPORT_AGENT_FAIL_ACTION,
      payload: err,
    });
  }
}

function* fetchSupportContacts() {
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/watersourceservice/society/contacts`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SUPPORT_CONTACTS_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SUPPORT_CONTACTS_FAIL_ACTION,
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchSupportContactsApi);

    yield put({
      type: actionTypes.FETCH_SUPPORT_CONTACTS_SUCCESS_ACTION,
      payload: resJSON?.data,
    });
    // }
  } catch (err) {
    if (err.status === 401) {
    }
    yield put({
      type: actionTypes.FETCH_SUPPORT_CONTACTS_FAIL_ACTION,
      payload: err,
    });
  }
}

function* fetchProfileData() {
  // const token = localStorage.getItem("fmsToken");
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/societydataservice/society/profile`,
    //   {
    //     method: "POST",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();
    const resJSON = yield call(fmApi.fetchProfileApi, data);

    yield put({
      type: actionTypes.FETCH_PROFILE_SUCCESS_ACTION,
      payload: resJSON,
    });
    // }
  } catch (err) {
    if (err.status === 401) {
    }
    yield put({ type: actionTypes.FETCH_PROFILE_FAIL_ACTION, payload: err });
  }
}

function* fetchSupportAddApartment() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/getapartmenttype`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SUPPRTADDAPT_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SUPPRTADDAPT_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);

    // return Res;
    const resJSON = yield call(fmApi.FetchApartmentTypeApi, data);

    yield put({
      type: actionTypes.FETCH_SUPPRTADDAPT_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SUPPRTADDAPT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* SupportActionWatcher() {
  yield takeEvery(actionTypes.FETCH_SUPPORT_INIT_ACTION, fetchSupport);
  yield takeEvery(actionTypes.ADD_SUPPORT_INIT_ACTION, addSupport);
  yield takeEvery(
    actionTypes.FETCH_SUPPORT_ISSUE_INIT_ACTION,
    fetchSupportIssueData
  );
  yield takeEvery(
    actionTypes.FETCH_SUPPORT_CHAT_INIT_ACTION,
    fetchSupportChatData
  );
  yield takeEvery(actionTypes.ADD_ISSUE_REPLY_INIT_ACTION, addIssueReply);
  yield takeEvery(actionTypes.FETCH_SUPPORT_AGENT_INIT_ACTION, fetchAgentsName);
  yield takeEvery(
    actionTypes.FETCH_SUPPORT_CONTACTS_INIT_ACTION,
    fetchSupportContacts
  );
  yield takeEvery(actionTypes.FETCH_PROFILE_INIT_ACTION, fetchProfileData);
  yield takeEvery(
    actionTypes.FETCH_SUPPRTADDAPT_INIT_ACTION,
    fetchSupportAddApartment
  );
}
